/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { createContext, useCallback, useContext, useReducer } from "react";
import {
	getHistoryAction,
	removeContactDataFromState,
	getContactSentimentAnalysisResults,
	setSMSMessageFormForContact,
} from "./actions";
import { initialState, reducer } from "./reducer";

const Context = createContext();

export const useContactData = () => useContext(Context);

export const ContactDataProvider = ({ children }) => {
	const [contactDataState, dispatch] = useReducer(reducer, initialState);

	const getContactHistory = useCallback(async (contact) => {
		await getHistoryAction(dispatch, { contact });
	}, []);

	const setContactSMSMessageForm = useCallback((contactId, smsMessageForm) => {
		setSMSMessageFormForContact(dispatch, contactId, smsMessageForm);
	}, []);

	const removeContactData = useCallback((contactId) => {
		removeContactDataFromState(dispatch, { contactId });
	}, []);

	const getSentimentAnalysisResults = useCallback(async (contact) => {
		return getContactSentimentAnalysisResults(dispatch, { contact });
	}, []);

	return (
		<Context.Provider
			value={{
				contactDataState,
				getContactHistory,
				removeContactData,
				getSentimentAnalysisResults,
				setContactSMSMessageForm,
			}}
		>
			{children}
		</Context.Provider>
	);
};
